import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';  // Import withRouter
import Topbar from '../../../Layout/topbar/Topbar';  // Import Topbar component
import Card from './Card';  // Import the Card component
import './Card.css';  // Optional, for global styles
import Util from "../../../Common/util";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCard: '', // Initially, no card is active
      zoomLevel: 1,  // Default zoom level (1 = 100%)
      cards: [
        { id: 'Card 1', heading: 'SO to Dispatch', subHeading: 'Can view report here', route: '/secondaryupload/so_to_dispatch', show: false },
        { id: 'Card 2', heading: 'Packing Task Data', subHeading: 'Can view report here', route: '/secondaryupload/packing_task_report', show: false },
        { id: 'Card 3', heading: 'Master Packing Task', subHeading: 'Can view report here', route: '/secondaryupload/master_packing_task_report', show: false },
        { id: 'Card 4', heading: 'PTL Incremental', subHeading: 'Can view report here', route: '/secondaryupload/incremental_data_report', show: false },
        { id: 'Card 5', heading: 'PTL Complete', subHeading: 'Can view report here', route: '/secondaryupload/complete_data_report', show: false },
        { id: 'Card 6', heading: 'Packing Station Zone Master', subHeading: 'Can view report here', route: '/secondaryupload/zone_master_report', show: false },
        { id: 'Card 7', heading: 'Packing Station Order Mapping', subHeading: 'Can view report here', route: '/secondaryupload/order_mapping_report', show: false },
        { id: 'Card 8', heading: 'Party Packed', subHeading: 'Can view report here', route: '/secondaryupload/party_packed_report', show: false },
        { id: 'Card 9', heading: 'PTL API Put Qty', subHeading: 'Can view report here', route: '/secondaryupload/ptl_api_put_qty_report', show: false },
        { id: 'Card 10', heading: 'Master PTL Data', subHeading: 'Can view report here', route: '/secondaryupload/master_ptl_data_report', show: false },
        { id: 'Card 11', heading: 'PTL Data', subHeading: 'Can view report here', route: '/secondaryupload/ptl_data_report', show: false },
        { id: 'Card 12', heading: 'Dispatch Confirm', subHeading: 'Can view report here', route: '/secondaryupload/dispatch_confirm_report', show: false },
        { id: 'Card 13', heading: 'Completed Van', subHeading: 'Can view report here', route: '/secondaryupload/completed_vans_report', show: false },
        { id: 'Card 14', heading: 'Bill Editing', subHeading: 'Can view report here', route: '/secondaryupload/bill_editing_report', show: false },
        { id: 'Card 15', heading: 'Bill Report', subHeading: 'Can view report here', route: '/secondaryupload/bill_report', show: false },
        { id: 'Card 16', heading: 'DRS Box Id', subHeading: 'Can view report here', route: '/secondaryupload/drs_box_id_report', show: false },
        { id: 'Card 17', heading: 'SO Dispatch', subHeading: 'Can view report here', route: '/secondaryupload/so_dispatch_report', show: false },
        { id: 'Card 18', heading: 'Inventory Allocation', subHeading: 'Can view report here', route: '/wmsReports/inventory_allocation_report', show: false },
        { id: 'Card 19', heading: 'CLD Dispatch', subHeading: 'Can view report here', route: '/wmsReports/cld_dispatch_report', show: false },
        { id: 'Card 20', heading: 'Secondary Bifurcation', subHeading: 'Can view report here', route: '/wmsReports/bifurcation_report', show: false },
        { id: 'Card 21', heading: 'Billwise To Case', subHeading: 'Can view report here', route: '/wmsReports/billwise_to_case_picksheet_report', show: false },
        { id: 'Card 22', heading: 'Integration Report', subHeading: 'Can view report here', route: '/wmsReports/integration_report', show: false },
        { id: 'Card 23', heading: 'STO Transaction', subHeading: 'Can view report here', route: '/wmsReports/sto_transaction', show: false },
        { id: 'Card 24', heading: 'Dues Report', subHeading: 'Can view report here', route: '/wmsReports/dues_report', show: false },
        { id: 'Card 25', heading: 'DRS CLD Report', subHeading: 'Can view report here', route: '/secondaryupload/drs_cld_report', show: false },
        { id: 'Card 26', heading: 'STO Report', subHeading: 'Can view report here', route: '/wmsReports/sto_report', show: false },
        { id: 'Card 27', heading: 'Bin Consolidation', subHeading: 'Can view report here', route: '/wmsReports/reports/binconsolidation', show: false },
        { id: 'Card 28', heading: 'Pick Task', subHeading: 'Can view report here', route: '/wmsReports/pick_task_report', show: false },
        { id: 'Card 29', heading: 'Pending Order Vs Available Qty', subHeading: 'Can view report here', route: '/wmsReports/pending_order_vs_available_qty', show: false },
        { id: 'Card 30', heading: 'Packed Crate', subHeading: 'Can view report here', route: '/wmsReports/packed_crate_report', show: false },
       
      ],
    };
  }

  componentDidMount() {
    this.detectZoomLevel();  // Detect zoom level on mount
    console.log("SIDEBAR", window.location.pathname);
    var directPutawayFlag = Util.getCookie("direct_putaway_flag");
    console.log('directPutawayFlag', directPutawayFlag);
    var NAV = Util.getCookie("userMenu").split("-");
    console.log('NAV', NAV);
    var location = Util.getCookie("selectedLocation");

    // Dynamically show/hide cards based on location and user permissions
    const updatedCards = [...this.state.cards];

    if (location.toLowerCase() === "vapi") {
      this.setState({
        showUpload: true,
        showBill: true,
      });
    } else {
      this.setState({
        showUpload: true,
        showBill: true
      });
    }

    // Set state based on the user's menu permissions
    if (NAV.indexOf("7.2.18") > -1) {
      updatedCards[0].show = true;
    }
    if (NAV.indexOf("7.2.1") > -1) {
      updatedCards[1].show = true;
    }
    if (NAV.indexOf("7.2.2") > -1) {
      updatedCards[3].show = true;
    }
    if (NAV.indexOf("7.2.3") > -1) {
      updatedCards[4].show = true;
    }
    if (NAV.indexOf("7.2.4") > -1) {
      updatedCards[5].show = true;
    }
    if (NAV.indexOf("7.2.5") > -1) {
      updatedCards[6].show = true;
    }
    if (NAV.indexOf("7.2.6") > -1) {
      updatedCards[7].show = true;
    }
    if (NAV.indexOf("7.2.7") > -1) {
      updatedCards[8].show = true;
    }
    if (NAV.indexOf("7.2.8") > -1) {
      updatedCards[9].show = true;
    }
    if (NAV.indexOf("7.2.9") > -1) {
      updatedCards[10].show = true;
    }
     if (NAV.indexOf("7.2.10") > -1) {
      updatedCards[11].show = true;
    }
    if (NAV.indexOf("7.2.11") > -1) {
      updatedCards[12].show = true;
    }
    if (NAV.indexOf("7.2.12") > -1) {
      updatedCards[13].show = true;
    }
    if (NAV.indexOf("7.2.13") > -1) {
      updatedCards[14].show = true;
    }
    if (NAV.indexOf("7.2.14") > -1) {
      updatedCards[15].show = true;
    }
    if (NAV.indexOf("7.2.15") > -1) {
      updatedCards[16].show = true;
    }
    if (NAV.indexOf("7.2.16") > -1) {
      updatedCards[17].show = true;
    }
    if (NAV.indexOf("7.2.17") > -1) {
      updatedCards[18].show = true;
    }
    if (NAV.indexOf("7.2.19") > -1) {
      updatedCards[19].show = true;
    }
    if (NAV.indexOf("7.2.20") > -1) {
      updatedCards[20].show = true;
    }
    if (NAV.indexOf("7.2.21") > -1) {
      updatedCards[21].show = true;
    }
    if (NAV.indexOf("7.2.22") > -1) {
      updatedCards[22].show = true;
    }
    if (NAV.indexOf("7.2.23") > -1) {
      updatedCards[23].show = true;
    }
    if (NAV.indexOf("7.2.24") > -1) {
      updatedCards[24].show = true;
    }
    if (NAV.indexOf("9.1.17") > -1) {
      updatedCards[25].show = true;
    }
    if (NAV.indexOf("9.1.18") > -1) {
      updatedCards[26].show = true;
    }
    if (NAV.indexOf("7.2.26") > -1) {
      updatedCards[27].show = true;
    }
     if (NAV.indexOf("7.2.26") > -1) {
      updatedCards[28].show = true;
    }
    if (NAV.indexOf("7.2.28") > -1) {
      updatedCards[29].show = true;
    }
    

    this.setState({ cards: updatedCards });
  }

  detectZoomLevel() {
    // Get the zoom level (device pixel ratio)
    const zoomLevel = window.devicePixelRatio || 1;
    this.setState({ zoomLevel });
  }

  handleCardClick = (cardName, url) => {
    this.setState({ activeCard: cardName });
    this.props.history.push(url);
  };

  chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  render() {
    const { activeCard, cards, zoomLevel } = this.state;
    const rows = this.chunkArray(cards.filter(card => card.show), 4);  // Chunk only visible cards into rows of 4

    // Adjust the layout and heading font size based on zoom level
    let cardSizeClass = '23%';
    let headingFontSize = '19px';  // Default font size for normal zoom
    let subHeadingFontSize = '14px'; // Default subheading font size
    let imageSize = "12px";  // Default image size
    let imagemaginLeft = "2%";

    if (zoomLevel >= 1.5) {
      cardSizeClass = '23%';
      headingFontSize = '15px';  // Larger font for zoom levels 1.5 and above
      subHeadingFontSize = '11px'; // Smaller subheading for zoom levels 1.5 and above
      imageSize = '10px'; // Smaller image for zoom levels 1.5 and above
      imagemaginLeft = "3%";
    } else if (zoomLevel >= 1.25) {
      cardSizeClass = '23%';
      headingFontSize = '14px';  // Larger font for zoom levels 1.25 and above
      subHeadingFontSize = '13px'; // Smaller subheading for zoom levels 1.25 and above
      imageSize = '5px'; // Adjusted image size for zoom levels 1.25
      imagemaginLeft = "3%";
    } else if (zoomLevel >= 1.1) {
      cardSizeClass = '23%';
      headingFontSize = '19px';  // Larger font for zoom levels <= 1.1
      subHeadingFontSize = '15px'; // Larger subheading for zoom levels 1.1
      imageSize = '12px'; // Larger image for zoom levels <= 1.1
      imagemaginLeft = "2%";
    }

    return (
      <div className="app1">
        <div className="card-container">
          {rows.map((row, rowIndex) => (
            <div key={rowIndex} className="card-row">
              {row.map((card, cardIndex) => (
                <Card
                  key={cardIndex}
                  heading={card.heading}
                  subHeading={card.subHeading}
                  route={card.route}
                  onClick={() => this.handleCardClick(card.id, card.route)}
                  isActive={activeCard === card.id}
                  className={cardSizeClass} // Apply zoom-based class to cards
                  cardSizeClass={cardSizeClass}
                  headingFontSize={headingFontSize} // Pass heading font size as a prop
                  subHeadingFontSize={subHeadingFontSize} // Pass subheading font size
                  imageSize={imageSize}  // Pass image size as a prop
                  imagemaginLeft = {imagemaginLeft}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default withRouter(App);
